export const batteryHealth = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
        battery_health:'Battery Health',
        battery_health_management:'Battery Health Management',
        add_battery_health:'Add Battery Health',
        edit_battery_health:'Edit Battery Health',
        cancel:'cancel',
        submit:'submit',
        battery_health_information:'Battery Health Information',
        battery_health_id:'Battery Health Id',
        battery_health_name:'Name',
        battery_health_status:'Status',
        battery_min:'Minimum',
        battery_max:'Maximum',
    },
    ar: {
        battery_health:'حالة البطارية',
        battery_health_management:'إدارة  البطارية',
        add_battery_health:'أضف حالة البطارية',
        edit_battery_health:'تعديل حالة البطارية',
        cancel:'إلغاء',
        submit:'إرسال',
        battery_health_information:'معلومات حالة البطارية',
        battery_health_id:'معرف حالة البطارية',
        battery_health_name:'الاسم',
        battery_health_status:'الحالة',
        battery_min:'الحد الأدنى',
        battery_max:'الحد الأعلى',
    }
}